import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useDeleteProfileRelationType = () => {
  const { authHeader } = useAuth();
  return useMutation(({ id }: { id: number }) => {
    return axios.delete(
      `${env.verifyServiceUrl}individual/profile_relationship_type/${id}/`,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
